/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yes. Any year from 1 to 3999 works, so 2024 becomes MMXXIV and 1994 becomes MCMXCIV. Paste the numeral from a clock face or film credit to read the year back as a normal number.`)
};

const es_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sí. Cualquier año del 1 al 3999 funciona, así que 2024 se convierte en MMXXIV y 1994 se convierte en MCMXCIV. Pega el numeral de la carátula de un reloj o del crédito de una película para leer el año nuevamente como un número normal.`)
};

const de_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Jedes Jahr von 1 bis 3999 funktioniert, sodass aus 2024 MMXXIV und aus 1994 MCMXCIV wird. Fügen Sie die römische Zahl von einem Zifferblatt oder Filmvorspann ein, um das Jahr als normale Zahl zurückzulesen.`)
};

const nl_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ja. Elk jaar van 1 tot 3999 werkt, dus 2024 wordt MMXXIV en 1994 wordt MCMXCIV. Plak het getal van een klokgezicht of filmcreditering om het jaar terug als een normaal getal te lezen.`)
};

const fr_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oui. N'importe quelle année de 1 à 3999 fonctionne, donc 2024 devient MMXXIV et 1994 devient MCMXCIV. Collez le chiffre à partir d'un cadran de montre ou du générique d'un film pour relire l'année comme un nombre normal.`)
};

const it_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sì. Qualsiasi anno da 1 a 3999 funziona, quindi 2024 diventa MMXXIV e 1994 diventa MCMXCIV. Incolla il numerale dal quadrante di un orologio o dai titoli di coda per leggere l'anno come un numero normale.`)
};

const pt_br2_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Qualquer ano de 1 a 3999 funciona, portanto 2024 se torna MMXXIV e 1994 se torna MCMXCIV. Cole o numeral de um mostrador de relógio ou crédito de filme para ler o ano como um número normal.`)
};

const pt_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sim. Qualquer ano de 1 a 3999 funciona, portanto 2024 torna-se MMXXIV e 1994 torna-se MCMXCIV. Cole o numeral de um mostrador de relógio ou crédito de filme para ler o ano de volta como um número normal.`)
};

const ja_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`はい。1〜3999の任意の年で機能するため、2024は MMXXIV になり、1994は MCMXCIV になります。時計の文字盤または映画クレジットから数字を貼り付けて、年を通常の数字として読み取ります。`)
};

const zh_rn_faq4_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可以。1 到 3999 之间的任何年份都适用，例如 2024 会转换为 MMXXIV，1994 会转换为 MCMXCIV。粘贴钟表表盘或电影片尾中的罗马数字，即可将年份还原为普通数字。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_faq4_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_faq4_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_faq4_a", locale)
	if (locale === "en") return en_rn_faq4_a(inputs)
	if (locale === "es") return es_rn_faq4_a(inputs)
	if (locale === "de") return de_rn_faq4_a(inputs)
	if (locale === "nl") return nl_rn_faq4_a(inputs)
	if (locale === "fr") return fr_rn_faq4_a(inputs)
	if (locale === "it") return it_rn_faq4_a(inputs)
	if (locale === "pt-BR") return pt_br2_rn_faq4_a(inputs)
	if (locale === "pt") return pt_rn_faq4_a(inputs)
	if (locale === "ja") return ja_rn_faq4_a(inputs)
	return zh_rn_faq4_a(inputs)
};